import { parse } from 'yaml'

export interface SkillParameter {
  name: string
  description: string | null
}

export function parseSkillParameters(content: string): SkillParameter[] {
  const match = /^---\r?\n([\s\S]*?)\r?\n---/.exec(content.trimStart())
  if (!match) return []

  let frontmatter: unknown
  try {
    frontmatter = parse(match[1])
  } catch {
    return []
  }

  if (!frontmatter || typeof frontmatter !== 'object' || Array.isArray(frontmatter)) return []
  const parameters = (frontmatter as Record<string, unknown>).parameters
  if (!parameters) return []

  if (!Array.isArray(parameters)) {
    if (typeof parameters !== 'object') return []
    return Object.entries(parameters as Record<string, unknown>).map(([name, description]) => ({
      name,
      description: typeof description === 'string' ? description : null,
    }))
  }

  return parameters
    .map(entry => {
      if (typeof entry === 'string') return { name: entry, description: null }
      if (entry && typeof entry === 'object' && typeof (entry as Record<string, unknown>).name === 'string') {
        const record = entry as Record<string, unknown>
        return {
          name: record.name as string,
          description: typeof record.description === 'string' ? record.description : null,
        }
      }
      return null
    })
    .filter((parameter): parameter is SkillParameter => parameter !== null)
}
